'use client';

import { cn } from '@/lib/utils';
import type { HttpMethod } from '@/lib/integrations/types';

interface MethodBadgeProps {
  method: HttpMethod;
  size?: 'sm' | 'md';
  className?: string;
}

const METHOD_COLORS: Record<HttpMethod, string> = {
  GET: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  POST: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  PUT: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  PATCH: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  DELETE: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
};

export function MethodBadge({ method, size = 'sm', className }: MethodBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center font-mono font-medium rounded',
        METHOD_COLORS[method],
        size === 'sm' ? 'px-1.5 py-0.5 text-xs' : 'px-2 py-1 text-sm',
        className
      )}
    >
      {method}
    </span>
  );
}

export default MethodBadge;
